<script>
	import { auth } from "@hitit/hub/src/stores";

	export let refreshToken = "";
	export let u = "HITIT_BYPASS_USERNAME";
	export let p = "HITIT_BYPASS_PASSWORD";

	function moveToAuth() {
		location.assign(
			`${"HITIT_BACKEND_URL"}oauth2/authorization/azure?response_type=code&client_id=web&redirect_uri=${
				window.location.origin
			}/login&scope=CLIENT`
		);
	}

	if (u && p) {
		$auth.bypassLogin(u, p);
	} else if (refreshToken) {
		(async () => {
			try {
				await $auth.checkRefreshToken();
			} catch (error) {
				moveToAuth();
			}
		})();
	} else {
		moveToAuth();
	}
</script>
